<template>
    <div class="defaultLayout bg-muted h-full min-h-screen">
        <div key="mainContent"
            class="p-2 pr-[2rem] dashboard-layout bg-muted h-auto min-h-screen">
            <div class="header relative z-10 ">
                <headerVue></headerVue>
            </div>

            <div class="page">
                <slot v-if="hasAccess" />
                <div class="page" v-else>
                    <UICard class="p-8 max-w-lg mx-auto flex items-center justify-center w-full">
                        <div class="flex flex-col items-center justify-center text-center">
                            <h1 class="text-2xl font-bold text-red-500 mb-4">Access Denied</h1>
                            <p class="text-text-secondary">You don't have the required permissions to view this page.</p>
                            <p class="text-text-secondary mt-2">Please contact your administrator if you need access.</p>
                            <UButton color="primary" variant="soft" icon="i-heroicons-arrow-left" class="mt-6"
                                @click="router.back()">
                                Go Back
                            </UButton>
                        </div>

                    </UICard>
                </div>
            </div>

            <div class="navigation relative z-20 h-full">
                <SideNavigation></SideNavigation>
                <!-- <MainMenuNavigation></MainMenuNavigation> -->
            </div>

            <PointshopPointCodeToolsHost />
        </div>
    </div>
</template>
<script setup lang="ts">
const route = useRoute();
const router = useRouter();
const hasAccess = ref(false);
const userinfo = useCookie<{ id?: number }>('USERINFO')
const userStore = useUserStore()

watchEffect(() => {
    const id = userinfo.value?.id
    if (id) userStore.setUser(id)
})


/* if (!userinfo.value) {
    console.log('default.vue: Redirecting to login - no userinfo', route.path)
    navigateTo({ path: '/login', query: { redirect_uri: encodeURIComponent(route.path) } }, { redirectCode: 302 })
} */

router.beforeResolve((to, from, next) => {
    // Set hasAccess based on route meta
    // If meta.hasAccess is undefined, default to true
    // Otherwise convert meta.hasAccess to boolean with !!
    hasAccess.value = to?.meta?.hasAccess === undefined ? true : !!to.meta.hasAccess
    next()
})

//initial server side check
hasAccess.value = route?.meta?.hasAccess === undefined ? true : !!route.meta.hasAccess

// Use useAsyncData to properly handle SSR data fetching
const { data: accessLevelData, error: accessLevelError } = await useAsyncData(
    'user-access-level',
    async () => {
        try {
            const accessLevel = await userStore.setAccessLevel()

            if (accessLevel && accessLevel.length > 0) {
                // Prefer URL params so SSR and client match (avoids hydration mismatch with localStorage).
                // Webpages area uses clientId / websiteId; legacy checks kept for other patterns.
                const clientParam = route.params.clientId ?? route.params.client
                const websiteParam = route.params.websiteId ?? route.params.website
                if (clientParam && websiteParam) {
                    userStore.setSelectedClient(Number(clientParam))
                    userStore.setSelectedWebsite(Number(websiteParam))
                } else {
                    // Otherwise use initializeClientSelection which respects lastSelectedCompiereId
                    userStore.initializeClientSelection()
                }
            }
            
            return { success: true, accessLevel }
        } catch (err: any) {
            if (err.statusCode == 403 || err.statusCode == 401) {
                console.log('Redirecting to login - unauthorized')
                throw showError({ statusCode: 403, statusMessage: 'Unauthorized' })
            } else {
                console.log('Error setting access level', err)
                throw showError({ statusCode: err.statusCode || 500, statusMessage: err.message || 'Error setting access level' })
            }
        }
    },
    {
        server: true,
        lazy: false
    }
)

// Handle redirect on error
if (accessLevelError.value) {
    if (accessLevelError.value.statusCode === 403 || accessLevelError.value.statusCode === 401) {
        console.log('default.vue: Redirecting to login - unauthorized', route.path)
        await navigateTo({ 
            path: '/login', 
            query: { redirect_uri: encodeURIComponent(route.path) } 
        })
    }
}
</script>

<style lang="scss">
.dashboard-layout {
    transition: all .5s ease;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas:
        "gridNav gridHeader"
        "gridNav gridPage";
    gap: 2rem;
    row-gap: 1rem;

    .header {
        grid-area: gridHeader;
    }

    .page {
        grid-area: gridPage;
    }

    .navigation {
        grid-area: gridNav;
    }
}


//// TRANSITION
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>